import type { TaskQueryParams } from '../types';
import type { BaseTaskService } from './base-task-service';

export const TaskService = Symbol.for('TaskService');

export interface TaskService extends BaseTaskService<TaskQueryParams> {}
